// Données de démonstration — remplace par ton API ou Firebase
export const MOCK_COLIS = [
  {
    id: 'COL-1234567',
    qr: 'QR-COL-1234567',
    expediteur: 'Aminata Diallo',
    tel: '77 123 45 67',
    destinataire: 'Moussa Sow',
    adresse: 'Rue 10, Villa 24, Parcelles Assainies',
    zone: 'Parcelles Assainies',
    description: 'Vêtements',
    poids: 2.5,
    statut: 'depot',
    livreur: '',
    date: new Date(Date.now() - 86400000).toISOString(),
    montant: 2500,
    paiement: 'wave',
  },
  {
    id: 'COL-2345678',
    qr: 'QR-COL-2345678',
    expediteur: 'Fatou Ba',
    tel: '78 987 65 43',
    destinataire: 'Ibrahima Diop',
    adresse: 'Villa 15, Cité Keur Gorgui, Point E',
    zone: 'Point E',
    description: 'Téléphone + accessoires',
    poids: 0.8,
    statut: 'affecte',
    livreur: 'Cheikh Mbaye',
    date: new Date(Date.now() - 3600000).toISOString(),
    montant: 1500,
    paiement: 'orange_money',
  },
  {
    id: 'COL-3456789',
    qr: 'QR-COL-3456789',
    expediteur: 'Oumar Ndiaye',
    tel: '76 555 44 33',
    destinataire: 'Rokhaya Mbaye',
    adresse: 'Derrière la grande mosquée, Pikine',
    zone: 'Pikine',
    description: 'Documents importants',
    poids: 0.3,
    statut: 'livre',
    livreur: 'Mamadou Fall',
    date: new Date(Date.now() - 172800000).toISOString(),
    montant: 1000,
    paiement: 'cash',
  },
  {
    id: 'COL-4567890',
    qr: 'QR-COL-4567890',
    expediteur: 'Seydou Diagne',
    tel: '70 444 33 22',
    destinataire: 'Mariama Cissé',
    adresse: 'Cité Fadia, Apt 3B, Médina',
    zone: 'Médina',
    description: 'Chaussures x2',
    poids: 1.2,
    statut: 'en_route',
    livreur: 'Abdou Sène',
    date: new Date(Date.now() - 7200000).toISOString(),
    montant: 2000,
    paiement: 'wave',
  },
];
